<template>
  <AddProduct />
</template>

<script>
import AddProduct from '../../../components/product/index.vue'
export default {
  components: {
    AddProduct,
  },
}
</script>

<style scoped lang="scss"></style>
